/**
 * T1104 · Platform slot 2 · SecureStore — web implementation.
 *
 * Web has NO secure storage primitive. The refresh token rides an
 * httpOnly cookie set by the auth service; sensitive secrets do NOT live
 * in browser storage. All three methods throw synchronously so callers
 * fail fast rather than silently caching to localStorage.
 *
 * `supported: false` lets shared code branch without try/catch.
 *
 * The slot satisfies the `SecureStorageSlot` shape from `../adapter.js`.
 */

import type { SecureStorageSlot } from '../adapter.js';

const ERR_MSG = 'SecureStore not supported on web — refresh token in httpOnly cookie.';

export function createWebSecureStoreSlot(): SecureStorageSlot {
  return {
    supported: false,
    getItem(): Promise<string | null> {
      return Promise.reject(new Error(ERR_MSG));
    },
    setItem(): Promise<void> {
      return Promise.reject(new Error(ERR_MSG));
    },
    removeItem(): Promise<void> {
      return Promise.reject(new Error(ERR_MSG));
    },
  };
}
